export const DOWNLOAD_FILES_AS_ZIP_FAILURE = 'DOWNLOAD_FILES_AS_ZIP_FAILURE';

export const downloadFilesAsZipFailure = error => ({
    type: DOWNLOAD_FILES_AS_ZIP_FAILURE,
    payload: error,
    error: true,
});
